import script from "./OnOffButton.vue?vue&type=script&setup=true&lang=js"
export * from "./OnOffButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__